import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { config } from '~/config';

import * as S from './ChartError.styles';

export const ChartError = () => {
  const { t } = useTranslation(['earnings', 'common']);

  return (
    <S.ChartErrorRoot data-testid="chart-error">
      <S.ErrorIcon iconName="ExclamationTriangle" />
      <S.Title> {t('earnings:error.title')}</S.Title>
      <S.Description>
        <Trans
          i18nKey={'earnings:error.description'}
          components={[
            <S.Link
              key="key-0"
              title={t('earnings:error.linkAlt')}
              href={`mailto:${config.supportEmail}`}
            />,
          ]}
          values={{ email: config.supportEmail }}
        />
      </S.Description>
    </S.ChartErrorRoot>
  );
};
